import React, { useState } from "react";
import { FaArrowCircleUp } from "react-icons/fa";
import { TopButton } from "../StyledComponent";

const ScrollButton = () => {
    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 100) {
            setVisible(true);
        } else if (scrolled <= 100) {
            setVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            /* you can also use 'auto' behaviour
         in place of 'smooth' */
        });
    };

    window.addEventListener("scroll", toggleVisible);

    return (
        <TopButton>
            <FaArrowCircleUp
                onClick={scrollToTop}
                style={{ display: visible ? "inline" : "none",float:'right',marginTop:'30px',marginLeft:"20px",width:'30px',height:'25px',color:"#3B4B95" }}
            />
       </TopButton>
    );
};

export default ScrollButton;